import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=39d6f0ca&scoped=true"
import script from "./ReportTable.vue?vue&type=script&lang=js"
export * from "./ReportTable.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ReportTable.vue?vue&type=style&index=1&id=39d6f0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6f0ca",
  null
  
)

/* custom blocks */
import block0 from "./ReportTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports